import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import ThemeToggle from '../../reusables/ThemeToggle/ThemeToggle';

const AppNavbar = () => {
    return (
        <Navbar bg="light" expand="lg" className='py-0'>
            <Container fluid>
                <Navbar.Brand href="/">
                    <img src="/ec-logo.png" width={150} height={80} alt="Logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="navbarNav" />
                <Navbar.Collapse id="navbarNav">
                    <Nav className="me-auto">
                        <Nav.Link href="/talks">Talks</Nav.Link>
                        <Nav.Link href="/techniques">Techniques</Nav.Link>
                        <Nav.Link href="/nuggets">Golden Nuggets</Nav.Link>
                        <Nav.Link href="/amrit-varsha">Amrit Varsha</Nav.Link>
                        <Nav.Link href="/programs">Programs</Nav.Link>
                    </Nav>
                    <ThemeToggle />
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default AppNavbar;